module.exports = __webpack_public_path__ + "static/media/logo_white.9637fba2.svg";